import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const statusTone = (s) => {
  const v = (s || "").toLowerCase();
  if (v === "complete" || v === "filed") return { bg: "#E3F4EA", text: "#1E6B43" };
  if (v.includes("query") || v.includes("awaiting")) return { bg: "#FDF0DC", text: "#8A5A12" };
  if (v === "not started") return { bg: "#EEF0F5", text: "#475069" };
  return { bg: "#E2F1FA", text: "#0B5E8A" };
};

export function StatusPill({ status, testId }) {
  const t = statusTone(status);
  return <span className="rounded-full px-2.5 py-0.5 text-[11px] font-semibold" style={{ background: t.bg, color: t.text }} data-testid={testId}>{status || "Not started"}</span>;
}

export default function StatusBox({ card, statuses, onChanged, readOnly }) {
  const options = statuses.includes(card.status) ? statuses : [card.status, ...statuses];
  const change = async (v) => {
    try {
      await api.put(`/cards/${card.id}/status`, { status: v });
      toast.success(`Status set to ${v}`);
      onChanged();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  const t = statusTone(card.status);
  return (
    <div className="rounded-xl border p-3" style={{ borderColor: `${t.text}33`, background: t.bg }} data-testid="card-status-box">
      <p className="text-[10px] uppercase tracking-[0.15em] font-semibold mb-1.5" style={{ color: t.text }}>Job status</p>
      <Select value={card.status} onValueChange={change} disabled={readOnly}>
        <SelectTrigger className="rounded-lg bg-white border-[#103080]/15 h-10 font-semibold text-[#103080]" data-testid="card-status-select"><SelectValue /></SelectTrigger>
        <SelectContent>{options.map((s) => <SelectItem key={s} value={s} data-testid={`card-status-option-${s.replace(/\s+/g, "-").toLowerCase()}`}>{s}</SelectItem>)}</SelectContent>
      </Select>
      <p className="text-[10px] text-[#0F172A]/50 mt-1.5">{readOnly ? "Updates automatically as tasks are completed. Admins can also change it by hand." : "Updates automatically when a linked task is completed. You can also change it by hand."}</p>
    </div>
  );
}
